import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import WizardInput from './WizardInput';

const ORGANIZATION_TYPES = [
  'Law Firm',
  'Title Company',
  'Escrow Company',
  'Real Estate Brokerage',
  'Mortgage Lender',
  'Signing Service',
  'Other'
];

const OrganizationAccountFields = ({ register, errors, setValue }) => (
  <Row className="g-2 mb-3">
    <Col sm={6}>
      <WizardInput
        label="Organization Name"
        name="organization_name"
        errors={errors}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('organization_name', {
            required: 'You must enter organization name'
          })
        }}
        setValue={setValue}
      />
    </Col>
    <Col sm={6}>
      <WizardInput
        type="select"
        label="Organization Type"
        name="organization_type"
        errors={errors}
        placeholder="Select organization type"
        options={ORGANIZATION_TYPES}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('organization_type', {
            required: 'You must select organization type'
          })
        }}
      />
    </Col>
  </Row>
);

OrganizationAccountFields.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired
};
export default OrganizationAccountFields;
